export function mergeAndRemoveDuplicates(originalIds, newIds) {
  // 合并两个数组
  const combinedIds = originalIds.concat(newIds);
  // 去除重复元素
  const uniqueIds = [...new Set(combinedIds)];
  return uniqueIds;
}

/**
 * 去掉字符串首尾空白。非字符串原样返回。
 */
export function trimInputValue<T>(value: T): T {
  return (typeof value === 'string' ? value.trim() : value) as T;
}

/**
 * 就地去掉对象上字符串字段的首尾空白。
 * @param keys 指定字段；不传则处理对象上全部自有属性
 * @returns 是否发生过变更
 */
export function trimObjectStringFields(
  obj: Record<string, any> | null | undefined,
  keys?: string[],
): boolean {
  if (!obj || typeof obj !== 'object' || Array.isArray(obj)) {
    return false;
  }
  let changed = false;
  const targetKeys = keys ?? Object.keys(obj);
  targetKeys.forEach((key) => {
    const val = obj[key];
    if (typeof val === 'string') {
      const trimmed = val.trim();
      if (trimmed !== val) {
        obj[key] = trimmed;
        changed = true;
      }
    }
  });
  return changed;
}


/**
 * 清理对象中的空值
 * 移除值为 null、undefined、空字符串、空数组的属性
 * @param obj 需要清理的对象
 * @returns 清理后的对象，如果清理后为空对象则返回 null
 */
export function cleanEmptyValues(obj: any): any | null {
  if (!obj || typeof obj !== 'object' || Array.isArray(obj)) {
    return null;
  }

  const cleanedObj: any = {};
  Object.keys(obj).forEach((key) => {
    const value = obj[key];
    // 保留有效值：非 null/undefined、非空字符串、非空数组
    if (
      value !== null &&
      value !== undefined &&
      value !== '' &&
      !(Array.isArray(value) && value.length === 0)
    ) {
      cleanedObj[key] = value;
    }
  });

  // 如果清理后的对象为空，返回 null
  return Object.keys(cleanedObj).length === 0 ? null : cleanedObj;
}
